export default {

    data() {
        return {
            modals: [],
        };
    },

    watch: {
        modals() {
            // Do not add the overflow when disabled
            if (this.addBodyOverflowOnModalOpen === false) {
                return;
            }

            if (this.modals.length) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'initial';
            }
        },
    },
};
